/**
 * Picture Styles gallery (Picture Tools ▸ Format and the picture mini toolbar).
 * Each style is a set of picture properties: frame radius, border stroke and an optional drop shadow.
 */
export const FRAME_STYLES = [
  { id: 'none', label: 'None', p: { borderRadius: 0, stroke: { width: 0 }, shadow: null } },
  { id: 'simple', label: 'Simple Frame', p: { borderRadius: 0, stroke: { width: 2, color: '#111827' }, shadow: null } },
  { id: 'white', label: 'Simple Frame, White', p: { borderRadius: 0, stroke: { width: 8, color: '#ffffff' }, shadow: { dx: 2, dy: 3, blur: 8, color: 'rgba(0,0,0,.35)' } } },
  { id: 'rounded', label: 'Rounded', p: { borderRadius: 16, stroke: { width: 0 }, shadow: null } },
  { id: 'soft', label: 'Soft Edge Rectangle', p: { borderRadius: 24, stroke: { width: 0 }, shadow: { dx: 0, dy: 4, blur: 14, color: 'rgba(0,0,0,.25)' } } },
  { id: 'oval', label: 'Oval', p: { borderRadius: 9999, stroke: { width: 0 }, shadow: null } },
  { id: 'drop', label: 'Drop Shadow', p: { borderRadius: 0, stroke: { width: 0 }, shadow: { dx: 6, dy: 6, blur: 10, color: 'rgba(0,0,0,.4)' } } },
  { id: 'accent', label: 'Accent Frame', p: { borderRadius: 4, stroke: { width: 4, color: '#7c3aed' }, shadow: null } },
];

/** Object property patch for a style. */
export const frameStyleProps = (f) => ({ borderRadius: f.p.borderRadius, stroke: { color: f.p.stroke.color || '#000', width: f.p.stroke.width, dash: 'solid' }, shadow: f.p.shadow });

/** Inline style for a small gallery thumbnail of a picture style. */
export const frameStyleThumb = (f) => ({
  borderRadius: Math.min(11, f.p.borderRadius / 2),
  border: f.p.stroke.width ? `${Math.min(3, f.p.stroke.width / 2)}px solid ${f.p.stroke.color}` : 'none',
  boxShadow: f.p.shadow ? '2px 2px 4px rgba(0,0,0,.4)' : 'none',
});

/** Id of the style currently applied to picture properties (or null). */
export const currentFrameStyle = (p = {}) => {
  const f = FRAME_STYLES.find((s) => (s.p.borderRadius || 0) === (p.borderRadius || 0) && (s.p.stroke.width || 0) === (p.stroke?.width || 0) && !!s.p.shadow === !!p.shadow && (!s.p.stroke.width || !s.p.stroke.color || s.p.stroke.color === p.stroke?.color));
  return f ? f.id : null;
};
